// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__C1Tfa","inputWrap":"CustomTip_inputWrap__2Mq8J"};